"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "postiglione": {
    "ac8f795e": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-zonzo": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ca0b41b2": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "skipSearch": false
    }],
    "duchessa": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f4142892": [{
      "hkey": "9bb5ba6a",
      "slug": "lago-rosso",
      "name": "Lago Rosso",
      "primary": true,
      "skipSearch": false
    }],
    "lagorosso": [{
      "hkey": "9bb5ba6a",
      "slug": "lago-rosso",
      "name": "Lago Rosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ddb5a441": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "skipSearch": false
    }],
    "monaco": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e9a78a94": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "skipSearch": false
    }],
    "salice": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9297f7b": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "skipSearch": false
    }],
    "sorgituro": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "85885b27": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "skipSearch": false
    }],
    "taverne-vecchie": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "48069dc5": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "skipSearch": false
    }],
    "tempe": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "044c5cf3": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "skipSearch": false
    }],
    "zancuso": [{
      "hkey": "e6e6d585",
      "slug": "postiglione",
      "name": "Postiglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;